import { render, staticRenderFns } from "./HistoryRfqReport.vue?vue&type=template&id=4696c60a&scoped=true"
import script from "./HistoryRfqReport.vue?vue&type=script&lang=js"
export * from "./HistoryRfqReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4696c60a",
  null
  
)

export default component.exports